import { NgModule, ModuleWithProviders } from '@angular/core'
import { CommonModule } from '@angular/common'
import { IcosMessageContainer } from './message'
import { IcosMessageService } from './message.service'

@NgModule({
  declarations: [IcosMessageContainer],
  exports: [IcosMessageContainer],
  imports: [CommonModule],
  entryComponents: [IcosMessageContainer],
})
export class IcosMessagesModule {
  static forRoot(): ModuleWithProviders {
    return { ngModule: IcosMessagesModule, providers: [
        IcosMessageService,
    ]}
  }
}
